import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "primereact/button";
import React, { useMemo } from "react";
import ProjectPage from "./ProjectPage";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { ScrollTop } from "primereact/scrolltop";
import useProjectStore from "@/shared/zustand/projectManagementStore";
import PageNotFound from "@/assets/images/page-not-found.svg";
// import NoProjects from "@/assets/images/no-projects.svg";
import { ArrowUp, Plus, X } from "lucide-react";
import { ProjectCard, ProjectCardsSkeleton } from "./ProjectCard";
import { sortOptions } from "@/constants/ProjectDashboardContstants";
// import { Paginator } from "primereact/paginator";
const ProjectDashboard = ({ 
// projects,
onNewProject, onProjectSelect, fetchingProjects, dashboardId, filtered, onClearFilter, }) => {
    const { searchTerm, projects, selectedProject, sortOrder = "date-desc", showProjectPage, setSelectedProject, setSearchTerm, setSortOrder, setShowProjectPage, pushToHistory, } = useProjectStore();
    // const [currentPage, setCurrentPage] = useState(1); // State for current page
    // const itemsPerPage = 12;
    const parseCustomTimestamp = (timestamp) => {
        if (!timestamp)
            return null;
        const [datePart, timePart] = timestamp.split(" ");
        if (!datePart || !timePart)
            return null;
        const [day, month, year] = datePart.split(":").map(Number);
        const [hours, minutes, seconds] = timePart.split(":").map(Number);
        // Construct a valid Date object
        const fullYear = year < 100 ? 2000 + year : year; // Handle two-digit year
        return new Date(fullYear, month - 1, day, hours, minutes, seconds);
    };
    const filteredAndSortedProjects = useMemo(() => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        const filteredProjects = projects.filter((project) => {
            const matchesName = project.name.toLowerCase().includes(lowerSearchTerm);
            const matchesCreator = (project.created_by ||
                (project.user?.join(", ") ?? ""))
                .toLowerCase()
                .includes(lowerSearchTerm);
            return matchesName || matchesCreator;
        });
        return filteredProjects.sort((a, b) => {
            switch (sortOrder) {
                case "name-asc":
                    return a.name.localeCompare(b.name);
                case "name-desc":
                    return b.name.localeCompare(a.name);
                case "date-asc": {
                    const dateA = parseCustomTimestamp(a.timestamp ?? "")?.getTime() || 0;
                    const dateB = parseCustomTimestamp(b.timestamp ?? "")?.getTime() || 0;
                    return dateA - dateB; // Oldest first
                }
                case "date-desc": {
                    const dateA = parseCustomTimestamp(a.timestamp ?? "")?.getTime() || 0;
                    const dateB = parseCustomTimestamp(b.timestamp ?? "")?.getTime() || 0;
                    return dateB - dateA; // Newest first
                }
                default:
                    return 0;
            }
        });
    }, [projects, searchTerm, sortOrder]);
    // const paginatedProjects = filteredAndSortedProjects.slice(
    //   (currentPage - 1) * itemsPerPage,
    //   currentPage * itemsPerPage
    // );
    // const handlePageChange = (e: any) => {
    //   setCurrentPage(e.page + 1); // PrimeReact Paginator uses zero-based indexing
    // };
    return !showProjectPage && !selectedProject?._id ? (_jsxs("div", { className: "p-5 flex flex-col gap-y-3 h-full", children: [_jsxs("div", { className: "flex gap-3 items-center h-10", children: [_jsx(InputText, { disabled: fetchingProjects || projects.length < 1, value: searchTerm, onChange: (e) => setSearchTerm(e.target.value), placeholder: "Search project...", className: "w-[260px] h-full border border-[#D1D5DB] px-3 py-3 rounded-[6px] text-sm", maxLength: 70 }), _jsx(Dropdown, { disabled: fetchingProjects ||
                            projects.length < 1 ||
                            filteredAndSortedProjects.length < 1, value: sortOrder, options: sortOptions, onChange: (e) => setSortOrder(e.value), placeholder: "Sort by", className: "custom-header-dropdown w-[200px] h-full border border-[#D1D5DB] rounded-[6px] text-sm", panelClassName: "shadow-md border border-[#d1d5db] rounded-[8px] mt-1" }), filtered && (_jsx(Button, { label: "Filtered Results", icon: _jsx(X, { size: 16 }), className: " bg-purple-50 text-[#5928ed] ml-auto  px-4 py-2 rounded-[6px] flex items-center gap-2 border border-[#D1D5DB]", onClick: onClearFilter })), _jsx(Button, { disabled: fetchingProjects, icon: _jsx(Plus, { size: 16 }), label: "New Project", text: true, className: "text-[#374151] h-full text-sm ml-auto  px-4 py-2 rounded-[6px] flex items-center gap-2 border border-[#D1D5DB]", onClick: onNewProject })] }), _jsxs("div", { className: "flex-1 overflow-auto", ref: dashboardId, children: [!fetchingProjects ? (filteredAndSortedProjects.length > 0 ? (_jsx("div", { className: "w-full py-3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 auto-rows-fr overflow-y-auto", style: {
                            gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
                        }, children: filteredAndSortedProjects.map((project) => (_jsx(ProjectCard, { project: project, onSelect: (project) => {
                                setShowProjectPage(true);
                                setSelectedProject(project);
                                pushToHistory(project); // Add to history when selecting from dashboard
                                onProjectSelect(project);
                            }, dashboardId: dashboardId }, project._id))) })) : (_jsxs("div", { className: "w-full flex flex-col justify-center items-center", children: [_jsx("div", { className: "w-[300px] object-contain", children: _jsx(PageNotFound, {}) }), _jsx("p", { className: "w-full text-xl my-auto text-center", children: "No projects found!" })] }))) : (_jsx(ProjectCardsSkeleton, {})), _jsx(ScrollTop, { target: "parent", threshold: 100, className: "size-8 bg-[#e0e0e0] *:text-[#000] ml-auto shadow-none ", icon: _jsx(ArrowUp, { size: 16 }) })] })] })) : (_jsx(ProjectPage, {}));
};
export default ProjectDashboard;
